// @flow

export const DEFAULT_COLOR = '#2e3192'
